module.exports = __webpack_public_path__ + "static/media/NZDS.66681148.png";